import { render, staticRenderFns } from "./BlockChecker.vue?vue&type=template&id=14d96bb8"
import script from "./BlockChecker.vue?vue&type=script&lang=js"
export * from "./BlockChecker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports